<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <loading :active.sync="loadingCal" :can-cancel="false" :is-full-page="true"></loading>
        <div :style="{'top': posicionLineaHora + 'px', 'position': 'relative'}" v-if="!loadingCal">
            <linea-hora/>
        </div>

        <table style="width: 100%">
            <tr>
                <th></th>
                <th v-for="diaSemana in semana.dias" v-bind:key="diaSemana.diaNumero">
                    {{diaSemana.diaEtiqueta}}
                </th>
            </tr>
    
            <tr>
                <th></th>
                <th v-for="diaSemana in semana.dias" v-bind:key="diaSemana.diaNumero">
                    <table style="width: 100%;border:solid 1px;">
                        <tr>
                            <td v-for="numeroSala in casillasSalas" v-bind:key="numeroSala" :style="anchoCalendario">
                                <div :style="anchoCalendario">
                                    <div class="titulo-sala" :style="anchoCalendario">{{numeroSala}}</div>
                                </div>
                            </td>
                            <td :style="anchoCalendario">
                                <div :style="anchoCalendario">
                                    <div class="titulo-sala" :style="anchoCalendario">E1</div>
                                </div>
                            </td>
                            <td :style="anchoCalendario">
                              <div :style="anchoCalendario">
                                <div class="titulo-sala" :style="anchoCalendario">E2</div>
                              </div>
                            </td>
                        </tr>
                    </table>
                </th>
            </tr>
    
            <tr v-for="hora in semana.horas" v-bind:key="hora.posicion"  class="casilla horas" :style="estiloLineaHora(hora)">
                <td>{{hora.horaEtiqueta}}</td>
    
                <td v-for="(casilla, indexCasilla) in casillas[hora.posicion]" v-bind:key="casilla.diaSemana"
                    :class="[indexCasilla%2 === 0 ? 'agenda-calendario-dia-par' : 'agenda-calendario-dia-impar', casilla.esfechaActual?'agenda-calendario-dia-actual':'']">
                    <div>
                        <table width="100%">
                            <tr>
                                <td v-for="sala in casilla.salas" v-bind:key="sala.numeroSala" :style="anchoCalendario"
                                    class="agenda-calendario-sala">
                                    <div v-if="sala.idBloque != null" class="comp-bloque"
                                         :style="mostrarPorFiltro(sala) ? 'background-color:'+sala.color+'; border: 1px solid #b5179e;' : ''"
                                         @click.self="crearCitaDesdeCalendario(casilla, sala)">
                                      <span style="display: none">id agenda empleado {{sala.idAgendaEmpleado}}</span>
                                      <sala-calendario-nuevo :style="anchoCalendario"
                                                    @asignarHoraLlegadaPaciente="asignarHoraLlegadaPaciente"
                                                    @obtenerSemana="obtenerSemana"
                                                     @consultarDetalle="consultarDetalle"
                                                     :numeroSala="sala.numeroSala" :cita="sala.cita"
                                                     :filtros="filtros"
                                                     @mostrarDetalle="mostrarDetalle"/>
                                    </div>
                                    <div v-else
                                         :style="mostrarPorFiltro(sala) ? 'background-color:'+sala.color : ''"
                                         @click.self="crearCitaDesdeCalendario(casilla, sala)">
                                      <span style="display: none">id agenda empleado {{sala.idAgendaEmpleado}}</span>
                                      <sala-calendario-nuevo :style="anchoCalendario"
                                                    @asignarHoraLlegadaPaciente="asignarHoraLlegadaPaciente"
                                                    @obtenerSemana="obtenerSemana"
                                                     @consultarDetalle="consultarDetalle"
                                                     :numeroSala="sala.numeroSala" :cita="sala.cita"
                                                     :filtros="filtros"
                                                     @mostrarDetalle="mostrarDetalle"/>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </td>
            </tr>
        </table>
    
    </div>
    </template>
    
    <script>

    import SalaCalendarioNuevo from "@/components/calendario/SalaCalendarioNuevo";
    import LineaHora from "@/components/NuevaAgenda/lineaHora";

    export default {
        name: "CalendarioSemanal",
        components: {
          LineaHora,
            SalaCalendarioNuevo
        },
        props: {
            idEspecialidadFiltro: Number,
            listaMotivosHerramientas: Array,
            listaMotivosCancelacion: Array,
            listaKitsPacienteNuevo: Array,
            filtros: Object
        },
        data: () => ({
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
            anchoCalendario: "width:30px;",
            loadingCal: false,
            numeroSalas: undefined,
            dias: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            semana: {},
            casillas: [],
            fechaInicio: undefined,

            showDialogIniciarSession: false,
            casillasSalas: [],
            horariosDoctor: Array,
    
            posicionLineaHora: 0,
            intervaloLineaHora: null,
            ejecutarIntervalo: true
        }),
        computed: {
    
        },
        created() {
          this.debug = this.$localStorageService.getDebug();
        },
        beforeDestroy() {
          clearInterval(this.intervaloLineaHora);
        },
        methods: {
            calcularAnchoCalendario(numeroSalas) {
              if (numeroSalas <= 4) {
                this.anchoCalendario = "width:30px;";
              } else {
                this.anchoCalendario = "width:" + (130 / (numeroSalas + 2)) + "px; font-size:8px;";
              }
            },
            horarioDoctor(casilla, numeroSala) {
              const indiceCasilla = this.$moment(casilla.fechaCasilla).format('YYYY/MM/DD') + '-' + casilla.horaCasilla1 + '-' + (numeroSala);
    
              let horarioDoctor = null;
    
              const indiceCasilla1 = (indiceCasilla+'-5');
              if (this.horariosDoctor[indiceCasilla1] !== undefined) {
                horarioDoctor = this.horariosDoctor[indiceCasilla1];
              } else if (this.horariosDoctor[indiceCasilla] !== undefined) {
                horarioDoctor = this.horariosDoctor[indiceCasilla];
              }
    
                return horarioDoctor;
            },
            pintarEventos(val, horariosDoctor) {
                this.horariosDoctor = horariosDoctor;
                this.semana.horas.forEach(hora => {

                    this.casillas[hora.posicion].forEach(casilla => {
                        casilla.salas.forEach(sala => {
    
                            let citasNormal = undefined;
    
                            let indiceCasilla = this.$moment(casilla.fechaCasilla).format('YYYY/MM/DD')+'-'+casilla.horaCasilla1 +'-'+ (sala.numeroSala);
    
                            if (val[indiceCasilla] !== undefined) {
                              citasNormal = val[indiceCasilla];
                            }
    
                            if (horariosDoctor[indiceCasilla] !== undefined) {
                                sala.idAgendaEmpleado = horariosDoctor[indiceCasilla].idAgendaEmpleado
                                sala.idEmpleado = horariosDoctor[indiceCasilla].idEmpleado;
                                sala.color = horariosDoctor[indiceCasilla].colorEspecialidad;
                                sala.idEspecialidad = horariosDoctor[indiceCasilla].idEspecialidad;
                                sala.idBloque = horariosDoctor[indiceCasilla].idBloque;
                                if(horariosDoctor[indiceCasilla].idBloque != null){
                                    sala.color = sala.color + 'border: 1px solid black;'
                                }
                            }
    
                            if(citasNormal !== undefined) {
                              sala.cita = citasNormal;
                            }
                        })
                    })
                });


                this.casillasSalas = Array();
    
                let contador = 1;
                for (let i = 0; i < this.numeroSalas; i++) {
                    this.casillasSalas.push(contador++);
    
                    if (contador > this.numeroSalas) {
                        contador = 1;
                    }
                }
            },
            calcularSemana(fechaRecibida, eventos, horariosDoctor, numero) {
                let fecha = new Date();
                fecha = new Date(fechaRecibida.toISOString());
                

                this.numeroSalas = numero;
    
                this.calcularAnchoCalendario(numero);
    
                this.semana = {};
    
                const mesSemana = this.$moment(fecha.toISOString()).format('MMMM YYYY');
                //
                // const fechaSemana = this.$moment(fecha).format('WW');
                // let numeroSemana = fechaSemana.week();
    
                this.semana.numeroSemana = "Semana " + this.$moment(fecha.toISOString()).week()  + " (" + mesSemana.charAt(0).toUpperCase() + mesSemana.slice(1) + ")";
    
                this.semana.dias = Array();
                fecha.setDate((fecha.getDate() - fecha.getDay()));
    
                this.fechaInicio = this.$moment(fecha.toISOString()).format('YYYY/MM/DD');
                this.llenarCasillas(fecha);
    
                for (let i = 0; i < 7; i++) {

                    this.semana.dias.push({
                        fecha: new Date(fecha),
                        diaEtiqueta: this.dias[fecha.getDay()] + " " + this.$moment(fecha.toISOString()).format('DD') + " de " +  this.$moment(fecha.toISOString()).format('MMM'),
                        diaNumero: fecha.getDay()
                    });
                    fecha.setDate(fecha.getDate() + 1);
                }
    
                let semana = this.semana.numeroSemana
                this.pintarEventos(eventos, horariosDoctor);
                this.obtenerSemana(semana)
                
            },
    
            calcularHoras() {
                this.semana.horas = Array();
                let fecha = new Date();
                fecha.setHours(7);
                fecha.setMinutes(0);
                fecha.setMilliseconds(0);
    
                for (let i = 0; i < 69; i++) {
                    this.semana.horas.push({
                     /* linea: 0,*/
                        posicion: i,
                        horaEtiqueta: this.$moment(fecha.toISOString()).format('HH:mm'),
                        horaEtiqueta1: this.$moment(fecha.toISOString()).format('HHmm'),
                    });
                    fecha.setMinutes(fecha.getMinutes() + 15);
                }

                this.lineaHoraAgenda();

                if(this.ejecutarIntervalo){
                  this.ejecutarIntervalo = false
                  this.intervaloLineaHora = setInterval(() => {
                    this.lineaHoraAgenda();
                  }, 15000);
                }
            },
    
            llenarCasillas(fechaInicio) {
                this.calcularHoras();
                this.casillas = Array();
    
                const diaActual = this.$moment().format('YYYY-MM-DD');
    
                this.semana.horas.forEach(horaSemana => {
                    const fechaCasilla = new Date();
                    fechaCasilla.setTime(fechaInicio.getTime());
                    const casillas = Array();
                    for (let i = 0; i < 7; i++) {
    
                        const fechaCasillaFormato = this.$moment(fechaCasilla.toISOString()).format('YYYY-MM-DD');
    
                        casillas.push({
                            diaSemana: i,
                            horaCasilla: horaSemana.horaEtiqueta,
                            horaCasilla1: horaSemana.horaEtiqueta1,
                            fechaCasilla: fechaCasillaFormato,
                            esfechaActual:  fechaCasillaFormato === diaActual,
                            salas: this.llenarSalas()
                        });
    
                        fechaCasilla.setDate(fechaCasilla.getDate() + 1);
                    }
    
                    this.casillas.push(casillas);
                });
    
            },
    
            llenarSalas() {
                const salas = Array();
                for (let i = 0; i < this.numeroSalas; i++) {
                    salas.push({
                        numeroSala: i + 1,
                        cita: undefined,
                        color: "inherit"
                    })
                }
                salas.push({
                    numeroSala: 100,
                    cita: undefined,
                    color: "inherit"
                })
    
                salas.push({
                  numeroSala: 101,
                  cita: undefined,
                  color: "inherit"
                })
    
                return salas;
            },
            obtenerSemana(semana){
                this.$emit("obtenerSemana", semana); 
            },
            asignarHoraLlegadaPaciente(datosCita){ 
                this.$emit("asignarHoraLlegadaPaciente", datosCita); 
            },
            consultarDetalle(cita) {
                this.$emit("consultarDetalle", JSON.parse(JSON.stringify(cita)));
            },
            crearCitaDesdeCalendario(casilla, sala) {

                if (this.$localStorageService.can('CA_06_crear_cita') && sala.cita === undefined
                    && this.$moment(casilla.fechaCasilla + ' ' +casilla.horaCasilla) >= this.$moment()) {
    
                    const horarioDoctor = this.horarioDoctor(casilla, sala.numeroSala);
                    if (horarioDoctor !== null) {
                        const datosAgregar = {
                            sillon: horarioDoctor.sillon,
                            idEmpleado: horarioDoctor.idEmpleado,
                            idEspecialidad: horarioDoctor.idEspecialidad,
                            fechaCita: casilla.fechaCasilla,
                            hora: casilla.horaCasilla.substring(0, 2),
                            minuto: casilla.horaCasilla.substring(3, 5),
                            nombreDoctor: horarioDoctor.nombreEmpleado
                        };
    
                        this.$emit("crearCitaDesdeCalendario", datosAgregar);
                    }
                }
            },

            estiloLineaHora(hora) {
              if (hora === undefined || hora === null || hora.horaEtiqueta === undefined || hora.horaEtiqueta === null) {
                return "";
              }
              const cadenas = hora.horaEtiqueta.split(":");
              if (cadenas[1] === "00") {
                return "border-top-width: 2px;border-top-color: #939393;";
              }
    
              return "";
            },
            mostrarDetalle(cita) {
              this.$emit("mostrarDetalle", cita);
            },
            mostrarPorFiltro(sala) {

              let mostrarEsp = this.filtros.selects.especialidades.map(Number).includes(sala.idEspecialidad);
              let mostrarDoctor = this.filtros.selects.doctores.map(Number).includes(sala.idEmpleado);
              let mostrarSillon = this.filtros.selects.sillones.map(Number).includes(sala.numeroSala);

              return (this.filtros.selects.especialidades.length === 0 || mostrarEsp)
                 && (this.filtros.selects.doctores.length === 0 || mostrarDoctor)
                  && (this.filtros.selects.sillones.length === 0 || mostrarSillon);

            },
            lineaHoraAgenda() {
              let fecha = new Date()
              let horaActual = fecha.getHours()+''+ (String(fecha.getMinutes()).length == 1 ? '0'+fecha.getMinutes() : fecha.getMinutes())
              let sumaAdicionalPorNomFechaSillones = this.casillasSalas.length <= 4 || this.casillasSalas.length >= 14 ? 57 : 45;

              for(let index = 0; index < this.semana.horas.length; index++) {
                if(!(Number(horaActual) >= Number(this.semana.horas[index].horaEtiqueta1))) {
                  this.posicionLineaHora = (27.25 * this.semana.horas[index].posicion) + sumaAdicionalPorNomFechaSillones
                  break;
                }
              }
            }
        }
    };
    </script>
    
    <!-- Add "scoped" attribute to limit CSS to this component only -->
    
    <style scoped>
    .titulo {
        background-color: rgba(0, 0, 0, .1);
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        text-align: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        font-size: 1.4em;
        line-height: 1.3;
        min-height: 2em;
        width: 100%;
        user-select: none;
    }
    
    .titulo span {
        position: relative;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }
    
    button:not(:disabled),
    [type="button"]:not(:disabled),
    [type="reset"]:not(:disabled),
    [type="submit"]:not(:disabled) {
        cursor: pointer;
    }
    
    .horas {
        color: #c9c9c9;
    }
    
    .casilla {
        border: #c9c9c9 solid 1px;
        height: 20px;
    }
    .casillaBlue {
      border: 1px solid  #c9c9c9;
      border-bottom: rgba(65, 103, 248, 0.78) solid 3px ;
      height: 20px;
    }
    </style>
    